import React from 'react'

export default function Login() {
  return (
    <div>
      <h2>Login Page</h2>
    </div>
  )
}

